import React from 'react'
import { createTheme, styled } from '@mui/material/styles';
import { ThemeProvider } from '@mui/material'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
//import { useLocation } from 'react-router-dom'
import { NavHashLink as Link } from 'react-router-hash-link'

const PriceList = () => {

	const myTheme = createTheme({
		typography: {
		  fontFamily: [
			'-apple-system',
			'BlinkMacSystemFont',
			'"Segoe UI"',
			'Roboto',
			'"Helvetica Neue"',
			'Arial',
			'sans-serif',
			'"Apple Color Emoji"',
			'"Segoe UI Emoji"',
			'"Segoe UI Symbol"',
		  ].join(','),
		},
	});

	const CustomHashLink = ({ to, children }) => {
		// const location = useLocation();
		// const selected = location.hash === to;
		const scroll=(el) => {
			const yOffset = -75;
			const y = el.getBoundingClientRect().top + window.pageYOffset + yOffset;
			window.scrollTo({ top: y, behavior: 'smooth' });
		}

		return (
			<Link
				to={to}
				scroll={scroll}
				// className={`${buttonClasses} ${selected ? 'selected' : ''}`}
				// onClick={()=>{setIsOpen(!isOpen)}}
			>
				{children}
			</Link>
		)
	}

	const StyledTableCell = styled(TableCell)(({ theme }) => ({

		[`&.${tableCellClasses.head}`]: {
			backgroundColor: theme.palette.primary.dark,
			color: theme.palette.common.white,
			fontSize: 20,
		},
		[`&.${tableCellClasses.body}`]: {
			fontSize: 18,
		},
	}));
	  
	const StyledTableRow = styled(TableRow)(({ theme }) => ({
		'&:nth-of-type(odd)': {
		  backgroundColor: theme.palette.grey[300],
		},
		'&:nth-of-type(even)': {
		  backgroundColor: theme.palette.grey[200],
		},// hide last border
		'&:last-child td, &:last-child th': {
		  border: 0,
		},
	}));

	const tableHeadCellStyles = {
		align: 'right',
		padding: '8px 10px',
	}
	const tableBodyCellStyles = {
		align: 'right',
		padding: '5px 10px',
	}

	function createData( text, price1, price2) {
		return { text, price1, price2 };
	}

	const table1Rows = [
		createData('pomoc a podpora při podávání jídla a pití', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při oblékání a svlékání vč. spec. pomůcek', '140,- Kč /hod', '130,-Kč/hod'),
		// createData('pomoc při drobném ošetř. úkonu (kt. není ve výhr. kompetenci zdravotnic. personálu, a poskytovaném v souladu s doporučením. ošetřuj. lékaře)', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při prostor. orientaci, samost. pohybu ve vnitř. prostoru', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při přesunu na lůžko nebo vozík', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table2Rows = [
		createData('pomoc při úkonech osobní hygieny', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při základní péči o vlasy a nehty', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při použití WC', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table3Rows = [
		createData(`dovoz - donáška jídla: ve městě Sokolov á 23,- Kč, obce: á 25,-Kč`),
		createData('pomoc při přípravě jídla a pití', '140,- Kč /hod', '130,-Kč/hod'),
		createData('příprava a podání jídla a pití', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table4Rows = [
		createData('běžný úklid a údržba domácnosti (např. i pomoc při praní a žehlení prádla v domácnosti klienta)', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při zajištění velkého úklidu domácnosti (např. sezónního úklidu, úklidu po malování, mytí oken)', '140,- Kč /hod', '130,-Kč/hod'),
		createData('donáška vody', '140,- Kč /hod', '130,-Kč/hod'),
		createData('topení v kamnech včetně donášky a přípravy topiva, údržba top.zařízení', '140,- Kč /hod', '130,-Kč/hod'),
		createData('běžné nákupy a pochůzky', '140,- Kč /hod', '130,-Kč/hod'),
		createData('velký nákup (např. týdenní nákup, nákup ošacení nebo nezbytného vybavení domácnosti)', '120,- Kč /úkon', '120,-Kč/úkon'),
		createData('praní a žehlení osobního a ložního prádla, příp. jeho drobné opravy', '100,- Kč /kg', '100,-Kč/kg'),
	];

	const table5Rows = [
		createData('doprovázení dětí - do školy, šk. zařízení, k lékaři, atd. a zpět', '140,- Kč /hod', '130,-Kč/hod'),
		createData('doprovázení dospělých - k lékaři, na instituce, atd. a zpět', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table6Rows = [
		createData('pomoc při komunikaci, vedoucí k uplatňování práv a oprávněných zájmů', '140,- Kč /hod', '130,-Kč/hod'),
		createData('pomoc při vyřizování běžných záležitostí', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table7Rows = [
		createData('dohled, aby osoba závislá na pomoci nezpůsobila ohrožení sobě ani svému okolí.', '140,- Kč /hod', '130,-Kč/hod'),
	];

	const table8Rows = [
		createData('Přeprava vozidlem organizace', 'Sokolov a D. Rychnov: 13,-Kč/km mimo tyto obce: 12,-Kč/km', 'Poskytováno výjimečně s ohledem na ostatní provoz po povolení ředitelky.'),
		createData('Pedikúra', '277,- Kč/úkon.', ''),
		createData('Zástřih vlasů, vodová ondul.', '210,- Kč/hod', 'Způsob vyúčtování: za každých započatých 15 min, vč. dopravy zaměstnance ke klientovi'),
		createData('Pomoc s nácvikem a upevňováním motorických, psychických a sociálních schopností a dovedností', '210,- Kč/hod', 'Způsob vyúčtování: dle skutečného času poskytnuté služby, vč. dopravy zaměstnance ke klientovi'),
	];

	const tables = [
		{ id: 1, title: 'Pomoc při zvládání běžných úkonů péče o vlastní osobu', price1text: 'do 80 hod/měs.', price2text: 'nad 80 hod/měs.', rows: table1Rows },
		{ id: 2, title: 'Pomoc při osobní hygieně (nebo posk. podmínek pro os. hygienu)', price1text: '', price2text: '', rows: table2Rows },
		{ id: 3, title: 'Poskytnutí stravy nebo pomoc při zajištění stravy', price1text: '', price2text: '', rows: table3Rows },
		{ id: 4, title: 'Pomoc při zajištění chodu domácnosti', price1text: '', price2text: '', rows: table4Rows },
		{ id: 5, title: 'Zprostředkování kontaktu se společenským prostředím', price1text: '', price2text: '', rows: table5Rows },
		{ id: 6, title: 'Pomoc při uplatňování práv, oprávněných zájmů, při obstarávání osobních záležitostí', price1text: '', price2text: '', rows: table6Rows },
		{ id: 7, title: 'Pomoc při zajištění bezpečí a možnosti setrvání v domácím prostředí', price1text: '', price2text: '', rows: table7Rows },
	]

	const CustomTable = ({ title, price1text, price2text, rows }) => (
		<>
			<TableHead>
				<TableRow>
					<StyledTableCell sx={{...tableHeadCellStyles, width: '60%'}}>{title}</StyledTableCell>
					<StyledTableCell align={tableHeadCellStyles.align} sx={{...tableHeadCellStyles, width: '20%' }}>{price1text}</StyledTableCell>
					<StyledTableCell align={tableHeadCellStyles.align} sx={{...tableHeadCellStyles, width: '20%' }}>{price2text}</StyledTableCell>
				</TableRow>
			</TableHead>
			<TableBody>
				{rows.map((row) => (
					<StyledTableRow key={row.text}>
						<StyledTableCell component="th" scope="row" sx={{...tableBodyCellStyles}}>
							{row.text}
						</StyledTableCell>
						<StyledTableCell align="right" sx={{...tableBodyCellStyles}}>{row.price1}</StyledTableCell>
						<StyledTableCell align="right" sx={{...tableBodyCellStyles}}>{row.price2}</StyledTableCell>
					</StyledTableRow>
				))}
			</TableBody>
		</>
	);

	return (
		<section id='priceList' className='container mx-auto px-2 py-3 mb-10'>
			<div className='my-3 mb-4 mx-auto text-center'>
				<h2 className='text-4xl w-fit mx-auto border-b-2 mb-2 border-amber-500 uppercase'>Ceník - Sazebník úkonů</h2>
				<p className='text-lg'>platný od 1. 1. 2026</p>
			</div>
			<div className="mx-auto text-center mb-2">
				<p className='text-sky-800 text-lg'>Obědy: á 90,- Kč; zachlazené á 95,- Kč. Dodavatel: Proxima gastro Chodov</p>
			</div>
			<div className='md:w-3/4 px-4 md:px-0 mx-auto text-lg'>
				<p className='mb-2'><CustomHashLink to='#zakladni'><strong className='hover:underline'>Základní činosti</strong></CustomHashLink> - mezi nejčastěji využívané úkony patří vedle dovozu obědů také <strong>nákupy</strong>, <strong>pochůzky</strong>, zajištění <strong>úklidu</strong>, <strong>dovoz</strong> a <strong>doprovod </strong> 
					klientů vozidlem Centra k vyřízení si nutných
					osobních záležitostí. <strong>Obědy</strong> jsou nakupovány od externího dodavatele, který stanovuje cenu oběda. Obědy rozvážíme v termojídlonosičích. Úkon <strong>praní</strong> a
					<strong> žehlení</strong> prádla zajišťujeme formou pomoci klientům přímo v jejich domácnostech nebo příp. formou pochůzek k dopravě prádla do komerčních a jiných prádelen ve městě
					a jeho blízkém okolí, případně vypráním a vyžehlením v prostorách organizace - viz. sazebník úkonů.</p>
				
				<p className='mb-2'><CustomHashLink to='#fakultativni'><strong className='hover:underline'>Fakultativní činosti</strong></CustomHashLink> - pouze v případě volných provozních kapacit.</p>
			</div>
			
			<div id='zakladni' className="md:w-3/4 px-4 md:px-5 mx-auto my-3">
				<p className='text-lg'><span className='text-2xl text-sky-800'>I. Základní činnosti</span> - dle § 6 vyhl. MPSV ČR č. 505/2006 Sb., v akt. znění a zák. č. 108/2006 Sb. v akt. znění</p>
			</div>
			<div className='md:w-3/4 px-4 md:px-0 mx-auto mb-5'>
				<ThemeProvider theme={myTheme}>
					<TableContainer component={Paper}>
						<Table aria-label="customized table">
							{
								tables.map((oneTable) => (
									<CustomTable key={oneTable.id} title={oneTable.title} price1text={oneTable.price1text} price2text={oneTable.price2text} rows={oneTable.rows}/>
								))
							}
						</Table>
					</TableContainer>
				</ThemeProvider>
			</div>
			<div id='fakultativni' className="md:w-3/4 px-4 md:px-5 mx-auto my-3">
				<p className='text-lg'><span className='text-2xl text-sky-800'>II. Fakultativní činosti</span> - poskytovány pouze v případě volných kapacit organizace.</p>
			</div>
			<div className='md:w-3/4 px-4 md:px-0 mx-auto'>
				<ThemeProvider theme={myTheme}>
					<TableContainer component={Paper}>
						<Table aria-label="customized table">
						<TableBody>
							{table8Rows.map((row) => (
								<StyledTableRow key={row.text}>
									<StyledTableCell component="th" scope="row" sx={{...tableBodyCellStyles}}>
										{row.text}
									</StyledTableCell>
									<StyledTableCell align="right" sx={{...tableBodyCellStyles}}>{row.price1}</StyledTableCell>
									<StyledTableCell align="right" sx={{...tableBodyCellStyles}}>{row.price2}</StyledTableCell>
								</StyledTableRow>
							))}
						</TableBody>
						</Table>
					</TableContainer>
				</ThemeProvider>
			</div>
		</section>
	)
}

export default PriceList

